<!-- Traveling Spirit -->
@if (ts) {
  <app-foldable-card [folded]="true" [lazy]="true">
    <div header>
      <h4 class="atmos-closet-ongoing__title">
        <app-spirit-type-icon [type]="'Season'" class="atmos-closet-ongoing__title-icon"></app-spirit-type-icon>
        @if (tsState === 'future') { <span>Upcoming Traveling Spirit</span> }
        @if (tsState === 'active') { <span>{{ ts.spirit.name }}</span> }
      </h4>
    </div>
    <div class="item-row">
      @for (item of tsItems; track item.guid) {
        <div class="atmos-closet-item-container">
          <div class="atmos-closet-item"
            (click)="itemToggled.emit(item)"
            [class.r]="state.selectedR()[item.guid]"
            [class.y]="state.selectedY()[item.guid]"
            [class.g]="state.selectedG()[item.guid]"
            [class.b]="state.selectedB()[item.guid]"
            [class.atmos-closet-highlight]="state.searchResults()?.[item.guid]">
            <app-item-icon [item]="item" [size]="state.itemSize()" [opaque]="true"[lazy]="false" />
          </div>
        </div>
      }
    </div>
  </app-foldable-card>
}

<!-- Returning Spirits -->
@if (rs) {
  <app-foldable-card [folded]="true" [lazy]="true">
    <div header>
      <h4 class="atmos-closet-ongoing__title">
        <app-spirit-type-icon [type]="'Season'" class="atmos-closet-ongoing__title-icon"></app-spirit-type-icon>
        <span>{{ rs.name }}</span>
      </h4>
    </div>
    <div class="item-row">
      @for (s of rsSpirits; track s.returning.spirit?.guid) {
        <div class="atmos-closet-ongoing__group">
          <div class="atmos-pill group-label">{{ s.returning.spirit.name }}</div>
          <div class="item-row">
            @for (item of s.items; track item.guid) {
              <div class="atmos-closet-item-container">
                <div class="atmos-closet-item"
                  (click)="itemToggled.emit(item)"
                  [class.r]="state.selectedR()[item.guid]"
                  [class.y]="state.selectedY()[item.guid]"
                  [class.g]="state.selectedG()[item.guid]"
                  [class.b]="state.selectedB()[item.guid]"
                  [class.atmos-closet-highlight]="state.searchResults()?.[item.guid]">
                  <app-item-icon [item]="item" [size]="state.itemSize()" [opaque]="true"[lazy]="false" />
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </app-foldable-card>
}

<!-- Events -->
@for (event of events; track event.instance.guid) {
  <app-foldable-card [folded]="true" [lazy]="true">
    <div header>
      <h4 class="atmos-closet-ongoing__title">{{ event.instance.event.name }}</h4>
    </div>
    <div class="item-row">
      <div class="atmos-closet-ongoing__group">
        <div class="atmos-pill group-label">In-game currency</div>
        <div class="item-row">
          @for (item of event.items; track item.guid) {
            <div class="atmos-closet-item-container">
              <div class="atmos-closet-item"
                (click)="itemToggled.emit(item)"
                [class.r]="state.selectedR()[item.guid]"
                [class.y]="state.selectedY()[item.guid]"
                [class.g]="state.selectedG()[item.guid]"
                [class.b]="state.selectedB()[item.guid]"
                [class.atmos-closet-highlight]="state.searchResults()?.[item.guid]">
                <app-item-icon [item]="item" [size]="state.itemSize()" [opaque]="true"[lazy]="false" />
              </div>
            </div>
          }
        </div>
      </div>
      <div class="atmos-closet-ongoing__group">
        <div class="atmos-pill group-label">In-App Purchase</div>
        <div class="item-row">
          @for (item of event.iapItems; track item.guid) {
            <div class="atmos-closet-item-container">
              <div class="atmos-closet-item"
                (click)="itemToggled.emit(item)"
                [class.r]="state.selectedR()[item.guid]"
                [class.y]="state.selectedY()[item.guid]"
                [class.g]="state.selectedG()[item.guid]"
                [class.b]="state.selectedB()[item.guid]"
                [class.atmos-closet-highlight]="state.searchResults()?.[item.guid]">
                <app-item-icon [item]="item" [size]="state.itemSize()" [opaque]="true"[lazy]="false" />
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </app-foldable-card>
}
